
export type tCustomer = {
    id: number; // Unique identifier for each customer
    name: string; // Name of the customer
    isCustomer: boolean; // Whether they are currently a paying customer
    paymentPerSprint: number; // The amount the customer pays per sprint
    numberOfSites: number; // The number of sites the customer has
    maxSites: number; // Maximum number of sites they can have
    requirements: tCustomerRequirement[]; // Array of requirements and feedback
    available: number; // when the customer can be onboarded
    icon: string; // Icon to display for the customer
}

export type tCustomerRequirement = {
    requirement: number
    feedback: string
}

export type tCustomerFeedback = {
    customerId: number
    feedback: string
}


// ☕ Espresso Yourself
// 🍳 Egg-cellent Bites
// 🍞 Flour Power
// 🍔 Burger Me
// 🍕 Pizza My Heart

export const customersData: tCustomer[] = [
    {
        id: 1,
        name: "Brewed Awakening",
        isCustomer: false,
        paymentPerSprint: 50,
        numberOfSites: 0,
        maxSites: 1,
        requirements: [
            {
                requirement: 1,
                feedback: 'I need an app I can login to!'
            }
        ],
        available: 0,
        icon: '☕'
    },
    {
        id: 2,
        name: "Lettuce Eat",
        isCustomer: false,
        paymentPerSprint: 50,
        numberOfSites: 0,
        maxSites: 2,
        requirements: [
            {
                requirement: 1,
                feedback: 'A good app needs a login screen.'
            },
            {
                requirement: 3,
                feedback: 'I need a "Forgot Password" feature.'
            }
        ],  
        available: 0,
        icon: '🥬'
    },
    {
        id: 3,
        name: "Pasta La Vista",
        isCustomer: false,
        paymentPerSprint: 75,
        numberOfSites: 0,
        maxSites: 3,
        requirements: [
            {
                requirement: 4,
                feedback: 'User roles would be a handy feature, roles not rolls.'
            },
            {
                requirement: 6,
                feedback: 'Staff login is a must feature.'
            },
            {
                requirement: 10,
                feedback: 'I am a bit worried about security when logging in.'
            }
        ],
        available: 0,
        icon: '🍝'
    },
    {
        id: 4,
        name: "The Codfather",
        isCustomer: false,
        paymentPerSprint: 25,
        numberOfSites: 0,
        maxSites: 4,
        requirements: [
            {
                requirement: 11,
                feedback: 'Everything is pointless without a table booking system setting up.'
            },
            {
                requirement: 14,
                feedback: "The staff need to be able ot manage bookings so I don't have to."
            },
            {
                requirement: 19,
                feedback: 'We keep having customers book at not turn up, can you fix that?'
            },
            {
                requirement: 93,
                feedback: 'I would love to be able to relax during my break 🕹️'
            }
        ],
        available: 0,
        icon: '🐟'
    },
    {
        id: 5,
        name: "Crepe Expectations",
        isCustomer: false,
        paymentPerSprint: 100,
        numberOfSites: 0,
        maxSites: 2,
        requirements: [
            {
                requirement: 21,
                feedback: 'Really struggling to keep track of what hours my staff are working.'
            },
            {
                requirement: 27,
                feedback: 'It would be great to see at a glance what the wages are for the week.'
            }
        ],
        available: 0,
        icon: '🥞'
    },
    {
        id: 6,
        name: "Wok This Way",
        isCustomer: false,
        paymentPerSprint: 150,
        numberOfSites: 0,
        maxSites: 3,
        requirements: [
            {
                requirement: 9,
                feedback: 'I think I would like to see who has tried to login and failed.'
            },
            {
                requirement: 45,
                feedback: 'We do outside catering so would love an invoice system.'
            },
            {
                requirement: 48,
                feedback: 'I hate end of year, can you make it easier?'
            }
        ],
        available: 1,
        icon: '🍜'
    },
    {
        id: 7,
        name: "Nacho Average Café",
        isCustomer: false,
        paymentPerSprint: 200,
        numberOfSites: 0,
        maxSites: 4,
        requirements: [
            {
                requirement: 81,
                feedback: 'The future is mobile, can you make it mobile?'
            },
            {
                requirement: 84,
                feedback: "People want to see table availability on their phone, it isn't 1999 anymore."
            },
            {
                requirement: 87,
                feedback: 'Can mobile users have a profile page?'
            },
            {
                requirement: 90,
                feedback: 'Customers want to use Pear Pay on their iPear phones.'
            }
        ],
        available: 2,
        icon: '🌮'
    },
    {
        id: 8,
        name: "Sole Mates",
        isCustomer: false,
        paymentPerSprint: 250,
        numberOfSites: 0,
        maxSites: 2,
        requirements: [
            {
                requirement: 17,
                feedback: 'Any chance of seeing booking history?'
            },
            {
                requirement: 18,
                feedback: 'Taking bookings is one thing, but they need to be able to cancel too.'
            }
        ],
        available: 3,
        icon: '🐟'
    },
    {
        id: 9,
        name: "The Daily Grind",
        isCustomer: false,
        paymentPerSprint: 175,
        numberOfSites: 0,
        maxSites: 3,
        requirements: [
            {
                requirement: 33,
                feedback: 'A purchase order system for suppliers would really help.'
            },
            {
                requirement: 36,
                feedback: 'This application really needs some stock reports'
            },
            {
                requirement: 39,
                feedback: 'Stock keeps going out of date, is there anything you could do about that?'
            }
        ],
        available: 4,
        icon: '☕'
    },
    {
        id: 10,
        name: "Bean There, Done That",
        isCustomer: false,
        paymentPerSprint: 50,
        numberOfSites: 0,
        maxSites: 5,
        requirements: [
            {
                requirement: 51,
                feedback: 'Customer feedback is really important to us.'
            },
            {
                requirement: 53,
                feedback: 'Our customers are saying they would love a loyalty card.'
            },
            {
                requirement: 54,
                feedback: 'A notification for when feedback has been left would be great.'
            },
            {
                requirement: 57,
                feedback: 'If a customer could see the history of their loyalty card they would see how amazing we are.'
            },
            {
                requirement: 60,
                feedback: 'Oh, one more thing, a loyalty program dashboard'
            }
        ],
        available: 5,
        icon: '☕'
    },
    // 🍣 Sushi, Roll With It
    {
        id: 11,
        name: "Sushi, Roll With It",
        isCustomer: false,
        paymentPerSprint: 500,
        numberOfSites: 0,
        maxSites: 1,
        requirements: [
            {
                requirement: 69,
                feedback: 'We urgently need to be able to track the kitchen staffs hours, please!'
            }
        ],
        available: 2,
        icon: '🍣'
    }

]